<template>
  <div :class="['theme__popup', { show: showDialog }]" v-click-outside="forceClose">
    <div style="display: flex; flex-direction: row">
      <div style="display: flex; width: 6rem">
        <button
          type="button"
          class="open-btn"
          @click="onClickOpen"
          style="font-size: 0.8rem; text-align: left; display: flex"
        >
          {{ keywords.length }}
          <VisibleText>&nbsp;keywords</VisibleText>
        </button>
      </div>
      <div style="display: flex; overflow-x: auto; overflow-y: hidden" class="light-scroll-bar">
        <div v-for="(keyword, index) in keywords" :key="index">
          <div
            style="font-size: 0.8rem; width: max-content; color: white"
            class="keywords-input-badge pill ui-adaptable"
            :style="{ 'background-color': theme.theme_color }"
          >
            {{ keyword }}
          </div>
        </div>
      </div>
    </div>

    <DialogPopup
      class="theme__popup-dialog"
      header-tag="h4"
      :show="showDialog"
      @close="showDialog = false"
      :class="
        isInThemeView ? 'theme__popup-themeView' : isInAutoView ? 'theme__popup-autoView' : ''
      "
    >
      <template #header>
        Keywords for the theme:
        <div
          class="theme__popup-dialog-name"
          style="
            font-family: Core-Sans;
            text-align: left;
            font-size: 1rem;
            text-transform: none;
            margin-left: 0.5rem;
            text-decoration: none;
          "
        >
          &nbsp;{{ theme.name }}
        </div>
      </template>
      <template #body>
        <div style="display: flex; flex-direction: column">
          <KeywordsInput
            style="padding: 1.5rem"
            :textAnalysisObject="textAnalysisObject"
            :hasPreProcessedText="hasPreProcessedText"
            :existingTheme="theme"
            class="ki-wrapper"
            :value="convertKeywords(theme)"
            :validate="(el) => !isBannedKeyword(el, true)"
            @tag-added="add(index, $event)"
            @tag-removed="remove(index, $event)"
            @banKeyword="saveBanKeyword($event)"
            :hideLabel="hideLabel"
          />
        </div>
      </template>
    </DialogPopup>
  </div>
</template>

<script>
import DialogPopup from '@/components/UI/DialogPopup.vue';
import textAnalysisMixin from '../Mixins/textAnalysisMixin.js';
import KeywordsInput from '../ProjectAnalysisTextMain/Components/KeywordsInput.vue';

export default {
  name: 'EditableKeywordsPopup',
  components: {
    DialogPopup,
    KeywordsInput,
  },
  mixins: [textAnalysisMixin],
  props: {
    theme: {
      default: () => {},
      type: Object,
    },
    textAnalysisObject: {
      default: () => {},
      type: Object,
    },
    hasPreProcessedText: {
      default: () => {},
      type: Boolean,
    },
    isInThemeView: {
      default: () => false,
      type: Boolean,
    },
    isInAutoView: {
      default: () => false,
      type: Boolean,
    },
    hideLabel: {
      default: () => false,
      type: Boolean,
    },
  },
  data() {
    return {
      showDialog: false,
    };
  },

  methods: {
    forceClose() {
      if (this.showDialog) this.showDialog = false;
    },
    onClickOpen() {
      this.showDialog = true;
    },
    isBannedKeyword(keyword, warnIfTrue = false) {
      if (!this.textAnalysisObject.bannedKeywords) return false;

      const val =
        this.textAnalysisObject.bannedKeywords.indexOf(keyword.trim().toLowerCase()) !== -1;
      if (val && warnIfTrue) {
        alert(`Can't add \`${keyword}\`. REASON - banned keyword.`);
      }
      return val;
    },
    convertKeywords(keywords) {
      let newKeywords = [];
      if (keywords.keyword_objects) {
        for (let i = 0; i < keywords.keyword_objects.length; i++) {
          let newKeyword = {
            index: 0,
            value: keywords.keyword_objects[i].keyword,
          };
          newKeywords.push(newKeyword);
        }
      }
      return newKeywords;
    },
    /* Theme methods */
    add(index, text) {
      let newKeyword = {
        theme: this.theme,
        text: text,
      };
      this.$emit('addKeyword', newKeyword);
    },
    remove(index, text) {
      let newKeyword = {
        theme: this.theme,
        text: text,
      };
      this.$emit('removeKeyword', newKeyword);
    },
  },
  computed: {
    keywords: function () {
      if (!this.theme.keyword_objects || !this.theme.keyword_objects.length) return [];
      const filtered_keywords = this.theme.keyword_objects.map((keywords) => keywords.keyword);
      if (filtered_keywords) return filtered_keywords;
      return [];
    },
  },
};
</script>
